import { LOCAL_STORAGE_TIME_ZONE } from "debug/components/SetLocalTime";
import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useExecuteActionMutation } from "redux/apis/debugAction";
import createPersistedState from "use-persisted-state";
const useAuthTokenState = createPersistedState<string | null>(
	"store.solitairetripeaks.com:authToken"
);

const useDebugAction = () => {
	const [searchParams] = useSearchParams();
	const [executeAction, { isLoading: isSetting, isError, isSuccess, error }] =
		useExecuteActionMutation();
	const [isNormalFlow, setIsNormalFlow] = useState(false);
	const [authToken] = useAuthTokenState();

	const [isLoggedIn, setIsLoggedIn] = useState(!!authToken);

	const setAction = async () => {
		const options = {
			configId: searchParams.get("debugactionid"),
			clearTimezone: searchParams.get("clearTimezoneOverride")
		};

		if (Object.values(options).some((val) => val !== null)) {
			if (!authToken) {
				localStorage.setItem(
					"store.solitairetripeaks.com:debugAction",
					options?.configId ?? ""
				);
				setIsNormalFlow(true);
				return;
			}
		}

		if (options.clearTimezone) {
			localStorage.removeItem(LOCAL_STORAGE_TIME_ZONE);
		}
		if (options.configId) {
			localStorage.removeItem("store.solitairetripeaks.com:debugAction");
			await executeAction(options).unwrap();
			return;
		}

		setIsNormalFlow(true);
	};

	useEffect(() => {
		if (process.env.REACT_APP_WITH_DEBUG === "true") {
			setAction();
			return;
		}
		setIsNormalFlow(true);
	}, [searchParams]);

	useEffect(() => {
		setIsLoggedIn(!!authToken);
	}, [authToken]);

	return { isSetting, isError, error, isSuccess, isNormalFlow, isLoggedIn };
};

export default useDebugAction;
